<template>
  <div>
    <div class="con-pagination-table vs-table--pagination">
      <div class="con-vs-pagination vs-pagination-primary md:flex items-center">
        <nav class="vs-pagination--nav">
          <button
            class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev md:p-0 p-8"
          >
            <span v-if="value.pageNumber == 1" disabled="disabled">
              <i class="vs-icon notranslate icon-scale material-icons null"
                >last_page</i
              >
            </span>
            <span v-else @click.prevent="changePageNumber(1)">
              <i class="vs-icon notranslate icon-scale material-icons null"
                >last_page</i
              >
            </span>
          </button>

          <button
            class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev ml-2 md:p-0 p-8"
          >
            <span v-if="previousPageDisabled" disabled="disabled">
              <i class="vs-icon notranslate icon-scale material-icons null"
                >chevron_right</i
              >
            </span>
            <span v-else @click.prevent="increasePageNumber(-1)">
              <i class="vs-icon notranslate icon-scale material-icons null"
                >chevron_right</i
              >
            </span>
          </button>
          <ul class="vs-pagination--ul">
            <li
              v-for="(i, index) in pages"
              :key="index"
              class="item-pagination vs-pagination--li md:p-0 p-8"
              :class="{ 'is-current': i == value.pageNumber }"
            >
              <span @click.prevent="changePageNumber(i)" class="mt-1">{{
                i
              }}</span>
              <div class="effect"></div>
            </li>
          </ul>
          <button
            class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-next mr-2 md:p-0 p-8"
          >
            <span v-if="nextPageDisabled" disabled="disabled">
              <i class="vs-icon notranslate icon-scale material-icons null"
                >chevron_left</i
              >
            </span>
            <span v-else @click.prevent="increasePageNumber(1)">
              <i class="vs-icon notranslate icon-scale material-icons null"
                >chevron_left</i
              >
            </span>
          </button>
          <button
            class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-next md:p-0 p-8"
          >
            <span
              v-if="value.pageNumber == pages[pages.length - 1]"
              disabled="disabled"
            >
              <i class="vs-icon notranslate icon-scale material-icons null"
                >first_page</i
              >
            </span>
            <span
              v-else
              @click.prevent="changePageNumber(pages[pages.length - 1])"
            >
              <i class="vs-icon notranslate icon-scale material-icons null"
                >first_page</i
              >
            </span>
          </button>
        </nav>
        <!-- <div class="md:my-0 my-3 text-center"> -->
        <div>
          <span class="mr-4"> تعداد کل : {{ value.total }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({
        pageNumber: 1,
        pageSize: 10,
        pageTotal: 0,
        total: 0,
      }),
    },
  },
  computed: {
    pages() {
      var nrOfPages = this.calculatePageCount();

      var delta = 2,
        range = [],
        rangeWithDots = [],
        l;

      range.push(1);

      if (nrOfPages <= 1) {
        return range;
      }

      for (
        let i = this.value.pageNumber - delta;
        i <= this.value.pageNumber + delta;
        i++
      ) {
        if (i < nrOfPages && i > 1) {
          range.push(i);
        }
      }
      range.push(nrOfPages);

      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push("...");
          }
        }
        rangeWithDots.push(i);
        l = i;
      }

      return rangeWithDots;
    },
    nextPageDisabled() {
      var pageCount = this.calculatePageCount();
      return pageCount <= this.value.pageNumber;
    },
    previousPageDisabled() {
      return this.value.pageNumber <= 1;
    },
  },
  data: () => ({}),
  mounted() {},
  methods: {
    onPageClick: function (item) {
      this.value.pageNumber = item;
      this.valueUpdated();
    },
    changePageNumber(value) {
      if (value == "...") return;
      this.value.pageNumber = value;
      this.valueUpdated();
    },
    increasePageNumber(value) {
      this.value.pageNumber += value;
      this.valueUpdated();
    },
    changePageSize() {
      this.valueUpdated();
    },
    calculatePageCount() {
      if (
        this.value.total > 0 &&
        this.value.pageSize > 0 &&
        this.value.total > this.value.pageSize
      ) {
        return Math.ceil(this.value.total / this.value.pageSize);
      }
      return 1;
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    getPagingTextData() {
      return {
        from:
          this.value.pageTotal > 0
            ? (this.value.pageNumber - 1) * this.value.pageSize + 1
            : 0,
        to:
          (this.value.pageNumber - 1) * this.value.pageSize +
          (this.value.pageTotal < this.value.pageSize
            ? this.value.pageTotal
            : this.value.pageSize),
        total: this.value.total,
      };
    },
    valueUpdated() {
      this.value.pageTotal = Math.ceil(this.value.total / this.value.pageSize);

      if (this.value.pageNumber > this.value.pageTotal)
        this.value.pageNumber = this.value.pageTotal;

      this.$emit("input", this.value);
      this.$emit("change", this.value);
    },
  },
};
</script>
<!-- <style>
  @media (max-width: 768px) {
    span i{
  font-size: 1.5rem !important;
}
li span{
  font-size: 1rem !important;
}
  }

</style> -->
